import React from 'react'
import { Link } from 'react-router-dom';
import blueTree from '../../../assets/career.png'
/**
* @author
* @function AboutUsPage
**/

export const AboutUsPage = (props) => {
    return (
        <section className="features">
            <div className="insruction">
                {/* Dont remove it */}
            </div>
            <div className="container">
                <div className="all-features flex flex-jc-c">
                    <div className=" flex  flex-jc-c flex-ai-c flex-di-col">
                        <div className="instruction_content">
                            <h1>We are working on this page.</h1>
                            <ol>
                                <li className="text-content">
                                  But, we all are students of GCOEY
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div className=" flex  flex-jc-c flex-ai-c flex-di-col">
                        <div className="instruction_images" style={{width:"100%"}}>
                            {/* <img src={blueTree} alt="" /> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
